export function GeneralElections2024Template(params) {
  var district87Template = "";

  var html = `
    <table class="esri-widget__table">
        <tbody>
            <tr>
                <th class="third">Precinct Name</th>
                <td class="two-third">{Name}</td>
            </tr>
            <tr>
                <th class="third">Detailed Report</th>
                <td class="two-third">
                    <a target="_blank" href="{Image}" target="_blank" class="ui fluid tiny button">
                        <i aria-hidden="true" class="external icon"></i> View PDF
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
    
    <div class="ui divider"></div>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">Presidential Results</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Names</th>
                <td class="two-third">{PresName}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{PresVote}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">US Senator Results</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{USSenName}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{USSenVote}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">US Representative</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{USRep}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{USRepVotes}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">State Representive</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{StateRep}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{StateRepVo}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">County Supervisor</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{CountySupe}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{SupervisVo}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">County Supervisor</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{CountySup2}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{SupervisV2}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">County Sheriff</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{CountySher}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{SheriffVot}</td>
            </tr>
        </tbody>
    </table>
    <table class="esri-widget__table">
        <thead>
            <tr>
                <th class="header" colspan="2">County Auditor</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th class="third">Candidate Name</th>
                <td class="two-third">{CountyAudi}</td>
            </tr>
            <tr>
                <th class="third">Votes Cast</th>
                <td class="two-third">{AuditorVot}</td>
            </tr>
        </tbody>
    </table>
    `;

  return html;
}
